export default {
  header: 'הוצאות',
  addNewExpense: 'הוספת הוצאה',
  sum: 'סכום',
  type: 'שם חיוב',
  date: 'תאריך',
  comments: 'הערות',
  isPaid: 'האם שולם',
  payDate: 'מתי שולם',
  sucess: 'החיוב נוסף בהצלחה',
  deletionReason: 'סיבת המחיקה',
  verifyDeletion: 'האם אתה בטוח שברצונך להעביר את החיוב לארכיון?',
  label: 'עריכת חיוב',
  delete: 'מחק חיוב',
  isRecurring: 'האם מחזורי',
  isRecurringActive: 'האם פעיל',
};
